var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.value.questionDescription || _vm.value.question.questionDescription)}}),_c('div',[_c(_vm.value.question
          ? _vm.value.question.questionType == 2
            ? 'el-checkbox-group'
            : 'el-radio-group'
          : _vm.value.questionType == 2
          ? 'el-checkbox-group'
          : 'el-radio-group',{tag:"div",model:{value:(_vm.value.isTrue),callback:function ($$v) {_vm.$set(_vm.value, "isTrue", $$v)},expression:"value.isTrue"}},_vm._l((_vm.value.answerList),function(item,index){return _c('div',{key:item.answerId,staticClass:"question-answer"},[_c(_vm.value.question
              ? _vm.value.question.questionType == 2
                ? 'el-checkbox'
                : 'el-radio'
              : _vm.value.questionType == 2
              ? 'el-checkbox'
              : 'el-radio',{tag:"div",attrs:{"label":item.questionAnswerId}},[_c('span',[_vm._v(_vm._s(_vm.letter[index])+".")]),_c('span',{domProps:{"innerHTML":_vm._s(item.questionAnswer)}})])],1)}),0)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }